const fi = {
  common: {
    unknown: 'Tuntematon',
    shipmentId: 'Tilaus ID',
    senderRef: 'Lähettäjä viite',
    phone: 'Puhelinnumero:',
    yes: 'Kyllä',
    no: 'Ei',
    cancel: 'Peruuta',
    somethingWentWrongTryAgain: 'Jotain meni pieleen, ole hyvä ja yritä myöhemmin uudelleen.',
    courier: 'Lähetti',
    done: 'Valmis',
    unsupportedBrowser: 'Päivitä selaimesi versio käyttääksesi kaikkia ominaisuuksia',
    blankText: '(Tyhjä)',
    updatedInformation: 'Päivitetty tieto',
    thanks: 'Kiitos!',
    edit: 'Muokkaa',
    confirmation: 'Vahvistus',
    required: 'pakollinen tieto'
  },
  skipToMainContent: 'Siirry pääsisältöön',
  countries: {
    sweden: 'Ruotsi',
    norway: 'Norja',
    denmark: 'Tanska',
    finland: 'Suomi'
  },
  pageNotFound: {
    title: 'Sivua ei löydy',
    message: 'Emme löydä etsimääsi sivua'
  },
  pageError: {
    title: 'Sisäinen palvelinvirhe',
    message: 'Pahoittelemme häiriötä. Yritä myöhemmin uudelleen.',
    reloadPage: 'Lataa sivu uudelleen'
  },
  application: {
    loading: 'Latautuu, odota hetki.'
  },
  feedbackBox: {
    title: 'Mitä mieltä olet',
    description:
      'Testaamme parhaillaan palvelua, jossa voit vastaanottajana seurata lähetyksiäsi reaaliajassa, kun ne ovat jakelussa. Haluaisimme kuulla mielipiteesi, <0>anna meille palautetta tämän linkin kautta</0>.'
  },
  menu: {
    shipmentTracking: 'Missä on toimitukseni?',
    aboutShipment: 'Tietoa toimituksestani',
    shipmentEvents: 'Tapahtumat'
  },
  logisticsProvider: {
    deliveredBy: 'Toimittaja'
  },
  deliveredShipment: { goodsDelivered: 'Tuotteesi on toimitettu!' },
  deviatedShipment: {
    goodsNotDelivered: 'Tuotteet eivät ole toimitettu',
    lastEvent: 'Viimeisin tapahtuma {{time}}',
    nextStep: {
      headline: 'Mitä tapahtuu seuraavaksi?',
      newAttempt:
        'Pyrimme toimittamaan lähetyksenne seuraavana arki päivänä. Vastaanotatte uuden ilmoituksen kun lähetys on lastattu kuljetusta varten.',
      returnToSender: 'Lähettäjän ohjeistuksien mukaisesti, lähetys palautetaan lähettäjälle.',
      pickupPoint: 'Lähettäjän ohjeistuksien mukaisesti, lähetys palautetaan lähettäjälle.',
      reachOut: 'Sinuun otetaan yhteyttä sopiaksemme uudesta toimituksesta.',
      homeDelivery: 'Yritämme sen sijaan toimittaa paketin kotiosoitteeseesi.'
    }
  },
  shipmentTracking: {
    showMapButton: 'Seuraa live-kartalla',
    map: 'Kartta',
    estimatedDeliveryTime: 'Arvioitu toimitusaika',
    deliveryTimeChanged: 'Arvioitua toimitusaikaasi muutettiin.',
    numberOfStopsLeft_one: '{{count}} toimitusta ennen sinua',
    numberOfStopsLeft_other: '{{count}} toimitusta ennen sinua',
    manyStopsLeft: 'Enemmän kuin {{many}} toimitusta ennen sinua',
    nextStop: 'Olet seuraava toimitus!'
  },
  aboutShipment: {
    delayMessageH2Message: ' Jos pakettisi viivästyy, yritämme toimittaa sen uudelleen seuraavana arkipäivänä.',
    plannedDeliveryTimeHeader: 'Arvioitu toimitusaika kohteesta {{customerName}}',
    header: 'Lähetyksesi kohteesta {{customerName}}',
    deliveryTime: 'Toimitusaika',
    timeWindow: 'välissä {{timeWindow}}',
    deliveryHeader: 'Toimitusosoite sekä yhteyshenkilö'
  },
  shipmentEvents: { header: 'Viimeisin muutos kohteesta {{customerName}}' },
  imageAlt: {
    calendarClockIcon: 'Kalenterin kello',
    checkIcon: 'Tarkistus nappi',
    pageNotFound: '404',
    thumbsUp: 'Peukku ylös',
    goodsOutsideDoor: 'Vara utanför dörr',
    idCard: 'Henkilökortti',
    image: 'Kuva',
    pageError: 'Sivulla tapahtui virhe',
    importantIcon: 'Tärkeää'
  },
  error: {
    cannotLoadMap: 'Karttaa ei voitu juuri nyt ladata, pahoittelumme.',
    invalidDeliveryDate: 'Valittu aika ei ole enään saatavilla. Ole hyvä ja päivitä sivu ja kokeile uudelleen.',
    title: 'Jotain meni vikaan!',
    errorClickToReload: 'Klikkaa tästä ladataksesi sivun uudelleen',
    phoneNumber: 'Väärä puhelinnumero! Oikea on +358 12345678.',
    phoneNumberPrefix: 'Sinun täytyy antaa maanumero, esim. +358...',
    CONSIGNMENT_ALREADY_ASSIGNED_TO_SLOT: 'Jokin meni vikaan, päivitä sivu.',
    INVALID_COUNTRY_CODE:
      'Toimitustasi koskevia tietoja puuttuu. Jos haluat edelleen, että se toimitetaan pakettiautomaattiin, ota yhteyttä asiakaspalveluun.',
    INVALID_LOCATION:
      'Toimitustasi koskevia tietoja puuttuu. Jos haluat edelleen, että se toimitetaan pakettiautomaattiin, ota yhteyttä asiakaspalveluun.',
    INVALID_DELIVERY_CONTACT_INFO:
      'Toimitustasi koskevia tietoja puuttuu. Jos haluat edelleen, että se toimitetaan pakettiautomaattiin, ota yhteyttä asiakaspalveluun.',
    INVALID_DELIVERY_PHONE:
      'Toimitustasi koskevia tietoja puuttuu. Jos haluat edelleen, että se toimitetaan pakettiautomaattiin, ota yhteyttä asiakaspalveluun.',
    CANNOT_ASSIGN_PARCEL_LOCKER: 'Tätä pakettiautomaattia ei voitu valita, valitse toinen.',
    CANNOT_CANCEL_PARCEL_LOCKER_DELIVERY: 'Jokin meni vikaan, yritä myöhemmin uudelleen.',
    staleInformation: 'Toimitustiedot eivät ole juuri nyt täysin ajan tasalla – haemme viimeisimmät tiedot.',
    notAValidNumber: 'Virheellinen numero'
  },
  event: {
    parcels: 'pakettia',
    outOf: 'määrästä',
    deviationHeadline: {
      'H-12': 'Emme pystyneet toimittamaan lähetystänne',
      'H-10': 'Emme löytäneet osoitettanne',
      'H-13': 'Lähetys tullaan palauttamaan',
      'V-41-K': 'Lähetys on ikävä kyllä myöhässä',
      'V-DB-AB': 'Lähetys on ikävä kyllä myöhässä',
      'H-BL-A': 'Emme päässeet',
      'H-11-Z': 'Emme löytäneet osoitettanne',
      'VI-16-X': 'Emme pystyneet toimittamaan lähetystänne',
      'V-100-CA': 'Emme voi toimittaa pakettiautomaattiin',
      'V-100-CI': 'Emme voineet toimittaa pakettiautomaattiin',
      'V-80-CI': 'Emme voineet toimittaa pakettiautomaattiin',
      'V-99-CI': 'Emme voineet toimittaa pakettiautomaattiin',
      'V-AO-CI': 'Emme voineet toimittaa pakettiautomaattiin'
    },
    deviation: {
      'H-12': 'Ikävä kyllä, emme saaneet ketään kiinni kohteessa',
      'H-11': 'Lähetys yritettiin toimittaa, mutta vastaanottajaa ei tavoitettu',
      'H-10': 'Emme pystyneet toimittamaan lähetystänne koska osoitetiedot olivat puutteelliset',
      'H-13': 'Koska et halunnut vastaanottaa sitä',
      '7-10': 'Tavaroita ei voitu noutaa puutteellisen osoitteen takia',
      '7-12': 'Lähettäjä ei ollut tavoitettavissä. Tavaroita ei ole noudettu',
      '7-82': 'Tavarat eivät olleet valmiit noudettavaksi',
      'V-41-K': 'Se tullaan laittamaan eteenpäin niin pian kuin mahdollista',
      'V-DB-AB': 'Se tullaan laittamaan eteenpäin niin pian kuin mahdollista',
      'H-07-R': 'Epäilyttävä, tai päihtynyt vastaanottaja',
      'H-07-Z': 'Epäilyttävä, tai päihtynyt vastaanottaja',
      'H-08-Z': 'Alaikäinen henkilö',
      'H-09-Z': 'Henkilöllisyystodistus puuttuu',
      'VI-16-X':
        'Tänään, kaikki ei mennyt niin kuin piti, emmekä pystyneet toimittamaan lähetystänne sovitusti. Pahoittelemme myöhästymistä',
      'H-BL-A': 'Ikävä kyllä emme pystyneet toimittamaan lähetystä pyytämäänne kohteeseen',
      'H-11-Z': 'Tyypillinen syy tähän on se että nimi tai numero puuttui ovesta',
      'V-100-CA': 'Alueellasi ei ole vapaita pakettiautomaatteja',
      'V-100-CI': 'Ei vapaata lokeroa',
      'V-80-CI': 'Paketti ylittää sallitut mitat/painon',
      'V-99-CI': 'Muu tuntematon',
      'V-AO-CI': 'Automaatti on epäkunnossa'
    },
    message: {
      created: 'Luotu',
      delivered: 'Toimitettu',
      collected: 'Noudettu',
      deviated: 'Poikkeama',
      'delivery-time-estimated': 'Päivitetty toimitusaika',
      'delivery-time-purchased': 'Lisämyynti: Lyhyempi aikaikkuna vastaanottajan tilaamana',
      'delivered-manually-overridden': 'Toimitettu',
      'deviated-manually-overridden': 'Poikkeama',
      'collected-manually-overridden': 'Noudettu',
      'flex-delivery-ordered': 'Yksinkertaistettu toimitus',
      flexDeliveryOrderedDescription: 'Yksinkertaistettu toimitus tilattu vastaanottajan toimesta',
      'flex-delivery-ordered-by-sender': 'Yksinkertaistettu toimitus tilattu lähettäjän toimesta',
      'flex-delivery-changed': 'Joustava toimitus muutettu',
      'reported-damaged': 'Vauriosta ilmoitettu',
      'reported-missing-article': 'Puuttuvista tuotteista ilmoitettu',
      'apartment-information-updated': 'Asunnon tiedot päivitetty',
      'service-upgrade-purchased': 'Lisämyynti: Vastaanottajan tilaama kuljetuspalvelu',
      'claim-registered-email-sent': 'Sähköposti viallisista tai puuttuvista tuotteista lähetetty',
      'parcel-locker-delivery-selected': 'Pakettiautomaatti valittu',
      'cancelled-parcel-locker-delivery': 'Pakettiautomaattitoimitus peruttu'
    }
  },
  date: {
    date: 'Päivämäärä',
    today: 'Tänään',
    tomorrow: 'Huomenna',
    yesterday: 'Eilen',
    from: 'Alkaen',
    fromDate: 'Alkupäivä',
    rangeOptions: {
      '15d': '+/- 15 päivää',
      '30d': '+/- 30 päivää',
      custom: 'Mukautetut päivämäärät',
      last30d: 'Viimeiset 30 päivää',
      last7d: 'Viimeiset 7 päivää',
      month: 'Kuukausi',
      today: 'Tänään',
      tomorrow: 'Huomenna',
      yesterday: 'Eilen'
    },
    to: 'Asti',
    toDate: 'Loppupäivä'
  },
  serviceUpsales: {
    heading: 'Haluatko, että tavarat toimitetaan sisälle?',
    selectDateTime: 'Valitse sisätoimituksen päivä ja aika',
    confirm: 'Siirry maksamaan',
    curbsideServiceInfo: 'Sisätoimituksessa toimitamme tavarat valitsemaasi paikkaan sisätiloissa.',
    orderService: 'Valitse sisätoimituksen aika (alkaen 399,-)',
    agreeToTerms: 'Tilaamalla hyväksyt <0>sisätoimituksen ehdot</0>.',
    noAvailableDeliveryTimesError: 'Jokin meni vikaan aikavälejä haettaessa. Lataa sivu uudelleen.',
    termsLink: 'Katso <0>sisätoimituksen ehdot</0>.',
    stateProgressedTooFar: 'Sisätoimitus ei ole enää mahdollista, koska toimituksesi on jo lisätty reitille.'
  },
  housingInfo: {
    housingTypeTitle: 'Asutko asunnossa vai talossa?',
    apartment: 'Asunto',
    house: 'Talo',
    selectConfirmationApartment:
      'Kiitos kun helpotat meitä toimittamaan lähetyksen. Varmistakaa <strong>että nimi</strong> on nähtävillä ovessa tai postilaatikossa.',
    selectConfirmationHouse:
      'Kiitos kun helpotat meitä toimittamaan lähetyksen. Varmistakaa <strong>että talon numero</strong> on nähtävillä talossa tai postilaatikossa.',
    apartmentInformation: 'Asunnon tiedot',
    gateCodeOrNameLabel: 'Porttikoodi tai nimi summerissa',
    floorNumber: 'Kerrosnumero',
    elevator: 'Hissi',
    selectOption: 'Valitse vaihtoehto',
    elevatorIsAvailable: 'Kyllä, hissi on käytössä',
    elevatorNotAvailable: 'Ei, hissi ei ole käytössä',
    submitError: 'Ole hyvä, täytä kerrosnumero',
    submit: 'Lähetä',
    submitChange: 'Lähetä Muutokset',
    confirmationText: 'Tämä helpottaa toimitusta.',
    confirmationHeader: 'Kiitos asuntonne tietojen päivittämisestä.'
  },
  flex: {
    header: 'Jätämmekö lähetyksen ovelle?',
    termsApproval: 'Painamalla kyllä hyväksyt meidän <1>termit</1>.',
    privacyPolicy: 'Löydät <1>Käyttöehdot</1> täältä.',
    deliverySpotHeader: 'Mihin toimitamme?',
    deliverySpotDefaultOption: 'Valitse kohta',
    deliverySpotTextHeader: 'Viesti kuljettajalle (max 50 kirjainta)',
    deliverySpotError: 'Valitse mihin tuotteet sijoitetaan',
    confirmationHeader: 'Kiitos, kun päivitit toimitustietosi.',
    confirmationText:
      'Toimitamme tilauksesi sovitusti {{location}}. Ilmoitamme teille kun toimitus on tehty. Kuljettaja saattaa ottaa kuvan toimituksesta.',
    infoText:
      'Toimitamme tilauksesi sovitusti {{location}}. Ilmoitamme teille kun toimitus on tehty. Kuljettaja saattaa ottaa kuvan toimituksesta.',
    infoTextAboutLockedApartmentBlocks:
      'Kuljettajillamme ei ole pääsyä lukittuihin kerrostaloihin, porraskäytäviin tai porttien ja puomien takana oleville alueille. Lähetys toimitetaan kontaktittomasti, jos kuljettaja löytää sopivan paikan.',
    unattendedCurbsideDeliveryHeader: 'Jätetäänkö toimitus, jos et ole kotona?',
    unattendedCurbsideDeliveryConfirmationText:
      'Toimitamme tavarat kontaktittomasti sopivaan paikkaan valitun toimitustavan mukaisesti, mikäli toimituspaikan olosuhteet sen sallivat. Toimituksen jälkeen vastaat tavaroista itse. Kuljettaja ottaa kuvan toimituksen sijainnista, ja saat ilmoituksen, kun toimitus on valmis.',
    unattendedCurbsideDeliveryInfoText:
      'Toimitamme tavarat kontaktittomasti sopivaan paikkaan valitun toimitustavan mukaisesti, mikäli toimituspaikan olosuhteet sen sallivat. Toimituksen jälkeen vastaat tavaroista itse. Kuljettaja ottaa kuvan toimituksen sijainnista, ja saat ilmoituksen, kun toimitus on valmis.',
    unattendedCurbsideDeliveryInfoText2:
      'Oletko kuitenkin kotona? Voit muuttaa valintaasi aina siihen asti, kunnes toimitamme.',
    notRingDoorBellText: 'Lähetti ei soita ovikelloa.',
    submitChanges: 'Lähetä muutokset',
    submit: 'Lähetä',
    terms: {
      header: 'Käyttöehdot',
      description: 'Toimitus oven ulkopuolelle – Näin se toimii:',
      details1:
        'Asiakkaana, te valitsette mihin me jätämme tuotteenne ja olette vastuussa että paikka on sopiva siihen. Muistakaa että sijainnin täytyy olla turvallinen sekä säänkestävä.',
      details2: 'Vastaanotat tekstiviestin kun lähetys on toimitettu.',
      details3: 'Toimituksen jälkeen, sinä vastaanottajana olet vastuussa lähetyksen vaurioista tai katoamisesta.'
    },
    unattendedCurbsideTerms: {
      description: 'Toimitus jalkakäytävän reunalle / tontin rajalle - näin se toimii:',
      details1:
        'Vastaanottajana hyväksyt toimituksen jalkakäytävälle tai tontin rajalle, ja olet vastuussa siitä, että paikka soveltuu toimitukseen. Muista, että toimitus ei saa estää kulkua tai liikennettä ja että se voi altistua sääolosuhteille.',
      details2: 'Saat tekstiviestin, joka vahvistaa, että tuote on toimitettu.',
      details3: 'Toimituksen jälkeen olet vastaanottajana vastuussa mahdollisista vahingoista tai katoamisesta.'
    },
    flexDeliveryCancelledInfo: 'Toimitamme tämän henkilökohtaisesti.',
    verifyDigitalIdentity: 'Vahvista henkilöllisyytesi'
  },
  digitalIdentity: {
    cta: {
      info: {
        header: 'Haluatko sujuvamman toimituksen?',
        se: 'Toimituksen sujuvuuden helpottamiseksi voit tunnistautua BankID:llä ennen toimitusajankohtaa',
        no: 'Toimituksen sujuvuuden helpottamiseksi voit tunnistautua BankID:llä ennen toimitusajankohtaa',
        dk: 'Toimituksen sujuvuuden helpottamiseksi voit tunnistautua MitID:llä ennen toimitusajankohtaa'
      },
      flex: {
        header: 'Tunnistus vaaditaan',
        se: 'Sinun tulee tunnistaa henkilöllisyytesi ennen kuin voimme toimittaa toimituksen ulos. Käytä yllä olevaa painiketta vahvistaaksesi henkilöllisyytesi BankID:llä.',
        no: 'Sinun tulee tunnistaa henkilöllisyytesi ennen kuin voimme toimittaa toimituksen ulos. Käytä yllä olevaa painiketta vahvistaaksesi henkilöllisyytesi BankID:llä.',
        dk: 'Sinun tulee tunnistaa henkilöllisyytesi ennen kuin voimme toimittaa toimituksen ulos. Käytä yllä olevaa painiketta vahvistaaksesi henkilöllisyytesi MitID:llä.'
      },
      button: { se: 'Allekirjoita BankID:llä', no: 'Allekirjoita BankID:llä', dk: 'Allekirjoita MitID:llä' }
    },
    verificationError: {
      header: 'Vahvistus epäonnistui',
      message:
        'Voit aina vastaanottaa lähetyksesi henkilökohtaisesti näyttämällä voimassa olevaa henkilötodistusta kuljettajan saapuessa tai voit yrittää suorittaa vahvistuksen vielä kerran'
    },
    verificationSuccess: {
      saveCodeHeader: 'Henkilöllisyyden vahvistus onnistui!',
      saveCodeText:
        'Tallenna tämä koodi ja ota se mukaasi, kun saat paketin, tai lähetä se noutajalle. Saat tekstiviestin, kun kuriiri on toimitusosoitteen ulkopuolella. Tämä koodi lähetetään myös tekstiviestinä.',
      nextPageVisit:
        'Vahvistuskoodisi on lähetetty sinulle tekstiviestillä, anna koodi kuljettajalle toimituksen yhteydessä.'
    },
    visibleDamageNotice:
      'Varmista, että tavarassa ei ole näkyviä vaurioita ennen toimituksen hyväksymistä. Kuljettajan tulee rekisteröidä näkyvät vauriot.'
  },
  damageInfo: {
    checkYourGoods: 'Muista tarkistaa tavarasi!',
    checkYourGoodsDescription: 'Puuttuuko jotain tai onko jokin vaurioitunut? Tee ilmoitus napsauttamalla alla',
    createReport: 'Tee ilmoitus',
    reportDamage: 'Ilmoita vauriosta',
    reportMissingArticle: 'Ilmoita puuttuvasta tuotteesta',
    reportMissingArticleOrDamage: 'Ilmoita puuttuvasta tuotteesta tai tavaran vauriosta',
    describeDamage: 'Kuvaile vaurio ja kirjoita tuotenumero',
    describeDamagePlaceholder: 'Esim. Kaappien reunoissa on vaurio. IKEA-tuotenumero: 1245688',
    uploadPhotoDamaged: 'Lataa kuva vaurioituneesta tavarasta',
    uploadPhotoDamagedText: 'Napsauta tästä tai vedä ja pudota',
    uploadPhotoDamagedDescription: 'Voit ladata enintään neljä kuvaa',
    uploadMaximumFileSizeLimit: 'Tiedoston koko saa olla enintään {{size}} KB',
    uploadTotalSizeOfAllPhotosLimit:
      'Kaikkien kuvien yhteiskoko saa olla enintään {{size}} KB. Jos kuvat ovat liian suuria, voit jakaa ilmoituksen kahteen osaan.',
    uploadAllowedFormats: 'Sallitut tiedostomuodot ovat {{formats}}',
    submit: 'Lähetä',
    unfinishedReport: 'Keskeneräinen ilmoitus',
    doYouWishToContinue: 'Tekemiäsi muutoksia ei tallenneta. Haluatko jatkaa?',
    stayOnPage: 'Pysy sivulla',
    continueWithoutSubmitting: 'Jatka lähettämättä',
    missingDescription: 'Sinun on annettava kuvaus',
    describeMissingArticle: 'Kirjoita puuttuvat tuotteet',
    describeMissingArticlePlaceholder: 'Esim. IKEA-tuotenumero: 1245688',
    articleDescriptionError: 'Sinun on annettava tuotenumero',
    confirmation: 'Vahvistus',
    reportSubmittedPara1:
      'Kiitos kun ilmoitit tilauksessasi olevasta virheestä. IKEA ottaa sinuun yhteyttä 24 tunnin kuluessa.',
    reportSubmittedPara2: 'Palaa aloitussivulle tai luo toinen raportti painamalla Valmis.',
    minimumFileSizeLimit: 'Sinun on liitettävä vähintään yksi tiedosto'
  },
  plannedDelivery: {
    headline: {
      delivery: 'Suunniteltu toimitusaika lähettäjän {{customer}} toimitukselle',
      pickupPoint: 'Toimituksesi lähettäjältä {{customer}} on varattu noudettavaksi',
      pickup: 'Toimituksesi lähettäjältä {{customer}} on nyt valmis noudettavaksi. Suunniteltu noutoaika',
      return: 'Palautuksesi suunniteltu noutoaika, vastaanottaja {{customer}}'
    },
    deliveryTimeInfo: 'Kun aloitamme jakelun, saat tarkemman, tunnin mittaisen arvion.',
    changeTime: 'Muuta päivää ja aikaa',
    newAttempt: 'Jos et ole paketin vastaanottamisen kotona, yritämme seuraavana työpäivänä uudelleen',
    pickupPoint: 'Jos et ole paketin vastaanottamisen kotona, se toimitetaan paikalliseen noutopisteeseesi',
    returnToSender: 'Jos et ole paketin vastaanottamisen kotona, se palautetaan lähettäjälle',
    delay: {
      headline: 'Toimituksesi on myöhässä.',
      text: ' Yritämme toimittaa sen sinulle seuraavana arkipäivänä'
    },
    movedToNextWorkingDay: {
      headline: 'Toimituksesi on siirretty seuraavalle työpäivälle.',
      text: 'Tässä näkyvä toimitusaika on päivitetty.'
    },
    notAvailable: {
      hd: {
        headline: 'Jokin näyttää menneen vikaan!',
        text: 'Soita asiakaspalveluumme ja varaa toimitukselle uusi aika, puhelinnumerot alla.'
      },
      nonHd: {
        headline: 'Valitettavasti meillä ei ole vielä toimitusarviota',
        text: ', mutta saat viestin, kun paketti on lastattu jakeluautoon, ja voit tarkistaa tämän sivun myöhemmin saadaksesi lisätietoja.'
      }
    }
  },
  timeBooking: {
    confirm: 'Vahvistaa',
    selectDeliveryTime: 'Valitse toimitusaika',
    header: 'Valitse päivä ja aika',
    price: 'hinta {{price}}',
    confirmation: {
      header: 'Vahvistus',
      ready: 'Kaikki valmista!',
      details: {
        delivery: 'Voit huoletta odottaa – me hoidamme loput. Olemme paikalla:',
        pickupPoint: 'Noutoaika varattu',
        pickup: 'Voit huoletta odottaa – me hoidamme loput. Tervetuloa luoksemme:',
        return: 'Voit huoletta odottaa – me hoidamme loput. Olemme paikalla:'
      },
      edit: 'Muuta'
    }
  },
  bookingNotPossible: {
    header: 'Varaus ei ole mahdollinen',
    details: {
      delivery:
        'Valitettavasti toimitusajan varaaminen verkossa ei ole juuri nyt mahdollista. Yritä myöhemmin uudelleen tai soita asiakaspalveluumme johonkin alla olevista puhelinnumeroista.',
      pickup:
        'Noutoaikaa ei voi varata verkossa juuri nyt. Yritä hetken kuluttua uudelleen tai soita asiakaspalveluumme johonkin alla olevista numeroista.',
      return:
        'Noutoaikaa ei voi varata verkossa juuri nyt. Yritä hetken kuluttua uudelleen tai soita asiakaspalveluumme johonkin alla olevista numeroista.'
    },
    'details-saas': {
      delivery:
        'Valitettavasti toimitusajan varaaminen verkossa ei ole juuri nyt mahdollista. Yritä myöhemmin uudelleen',
      pickup: 'Noutoaikaa ei voi varata verkossa juuri nyt. Yritä hetken kuluttua uudelleen.',
      return: 'Noutoaikaa ei voi varata verkossa juuri nyt. Yritä hetken kuluttua uudelleen.'
    }
  },
  paymentFailed: {
    header: 'Maksu epäonnistui',
    details: 'Yritä uudelleen myöhemmin tai soita asiakaspalveluumme johonkin alla olevista puhelinnumeroista.',
    detailsSaas: 'Valitettavasti emme voineet suorittaa maksua. Yritä uudelleen myöhemmin.',
    goBack: 'Palaa seurantasisältösivulle'
  },
  pickupTracking: { estimatedPickupTime: 'Arvioitu noutoaika', goodsPickedUp: 'Lähetys on noudettu!' },
  environmentFriendly: {
    fossilFreeDelivery1: 'Lähetyksesi on ',
    fossilFreeDelivery2: 'fossiili vapaa.',
    zeroEmissionDelivery: 'Lähetyksesi toimitetaan ',
    bicyclePreposition: '',
    carPreposition: '',
    electric: 'sähköauto.',
    bicycle: 'polkupyörä.',
    hydrogen: 'vetyauto.',
    bring: {
      electric: '100% sähkö',
      bicycle: '100% lihaskäyttöinen',
      hydrogen: '100% vety',
      fossilFreeDelivery: '100% fossiilivapaa polttoaine',
      naturally: 'luonnollisesti'
    }
  },
  ikeaDeliveryNote: {
    doYouNeedADeliveryNote: 'Tarvitsetko lähetysluettelon IKEAlta?',
    noProblemViewItHere: 'Ei hätää! Voit katsoa ja tulostaa sen täällä.',
    viewDeliveryNote: 'Näytä lähetysluettelo'
  },
  deliveryNote: {
    title: 'Lähetysluettelo',
    sender: 'Sender',
    vatNumber: 'ALV-numero',
    orderNumber: 'Tilausnumero',
    receiver: 'Receiver',
    phone: 'Phone',
    shipmentId: 'Lähetystunnus',
    articles: 'Articles',
    orderDate: 'Tilauspäivä',
    deliveryDate: 'Toimituspäivä',
    deliveryTime: 'Toimitusaika',
    printedDate: 'Tulostuspäivä',
    receiversReference: 'Vastaanottajan viite',
    receiversReferenceNote: 'Käytä tätä numeroa kaikissa yhteydenotoissa meihin',
    articleNumber: 'Number',
    articleName: 'Name',
    articlePrice: 'Yksikköhinta',
    articleQuantity: 'Quantity',
    numberOfPackages: 'Pakettien lukumäärä',
    totalWeight: 'Kokonaispaino',
    totalVolume: 'Kokonaisvolyymi',
    print: 'Tulosta lähetysluettelo'
  },
  timewindowpurchase: {
    headline: 'Haluatko tarkemman toimitusajan?',
    toPayment: 'Siirry maksamaan',
    approve: 'Hyväksyn',
    termsLink: 'ehdot',
    selectTimeWindow: 'Valitse aikaikkuna',
    selectTimeWindowError: 'Sinun on valittava aikaikkuna',
    paymentInProgress: 'Tilaustasi ei voitu päivittää juuri nyt, koska maksu on kesken.',
    stateProgressedTooFar:
      'Lyhyemmän aikaikkunan valitseminen ei ole enää mahdollista, koska toimituksesi on jo lisätty reitille.',
    generalError: 'Maksua ei voida jatkaa. Yritä myöhemmin uudelleen.'
  },
  requestPhoneNumber: {
    header: 'Tekstiviesti-ilmoitus',
    help: 'Lisää puhelinnumerosi jotta saat toimitus ilmoitukset tekstiviestillä.',
    label: 'Sinun puhelinnumerosi',
    save: 'Tallenna numero',
    done: 'Kiitos! Saat jatkossa ilmoitukset tekstiviestillä.'
  },
  contact: {
    questions: 'Jos sinulla on kysyttävää,',
    callUs: 'voit soittaa asiakaspalveluumme.',
    contactUs: 'voit ottaa meihin yhteyttä osoitteessa ',
    sasCustomerServicePrefix: 'Ota yhteyttä SAS:n asiakaspalveluun:'
  },
  vasDescription: { header: 'Lähetyksesi kohteesta' },
  christmas: {
    title: 'Levitä lämpöä arkeesi',
    description: 'Toimitamme mielellämme lähimpään pakettiautomaattiin, noutopisteeseen tai suoraan kotiisi.',
    thankYou: 'Kiitos!',
    wishRegistered: 'Toiveesti on lisätty toivelistalle',
    seeMoreLink: 'Mikä on joulutoiveesi?'
  },
  altText: { previewImage: 'Katso kuva' },
  purchaseReceipt: {
    purchaseOfTimeWindowHeading: 'Uusi toimitusaikasi on tilattu ja vahvistettu',
    serviceUpgradeHeading: 'Toimituksen päivitys on tilattu ja vahvistettu',
    receipt: 'Maksukuitti',
    companyName: 'Bring E-commerce & Logistics AB',
    organisationNumber: 'Kaupparek.nro: 556546-4939',
    orderNumber: 'Tilausnumero',
    date: 'Päivämäärä',
    time: 'Kellonaika',
    service: 'Palvelu',
    purchaseOfTimeWindow: 'Toimituksen aikaikkuna',
    serviceUpgrade: 'Toimitus siätiloihin',
    gross: 'Yhteensä ilman ALV:a',
    vat: 'ALV ({{vat}} %)',
    total: 'Yhteensä'
  },
  parcelLocker: {
    heading: 'Toimitammeko pakettisi pakettiautomaattiin?',
    additionalInfo: 'Valitse Kyllä, jos haluat, että toimitamme pakettisi lähelläsi olevaan pakettiautomaattiin.',
    additionalInfoWithParcelLockerSelected: 'Valitse, mihin pakettiautomaattiin haluat meidän jättävän paketin.',
    pickupLocation: 'Noutopaikka',
    selectParcelBox: 'Valitse pakettiautomaatti',
    selectParcelBoxValidationError: 'Valitse pakettiautomaatti',
    sendIn: 'Lähetä',
    deliverPackageTo: 'Toimitamme pakettisi kohteeseen',
    deliveredText: 'Pakettisi on toimitettu pakettiautomaattiin',
    bannerHeading: 'Tärkeää tietoa',
    bannerDescription: 'Avaa valitsemasi pakettiautomaatti Posten-sovelluksella.',
    futureDeliveryText: 'Pakettisi toimitetaan pakettiautomaattiin.',
    deliveryOrderedByReceiver: 'Vastaanottaja on tilannut toimituksen pakettiautomaattiin',
    nextStop: 'Pakettiautomaattisi on seuraava pysähdys',
    manyStopsLeft: 'Yli {{many}} pysähdystä jäljellä ennen kuin toimitamme pakettisi pakettiautomaattiin.',
    numberOfStopsLeft: '{{count}} pysähdys ennen kuin toimitamme pakettisi pakettiautomaattiin.',
    numberOfStopsLeft_other: '{{count}} pysähdystä ennen kuin toimitamme pakettisi pakettiautomaattiin.',
    cannotCancelMessage: 'Pakettiautomaattiin toimittamisen valintaa ei voi perua.'
  },
  cancelDeliveryTime: {
    cancelButton: 'Peruuta toimituksen aikaikkuna',
    preCancellationInfoText:
      'Jos tämä aikaikkuna ei sovi, voit peruuttaa toimitusajan, ja ilmoitamme sinulle uuden toimitusaikaikkunan.',
    postCancellationConfirmationText:
      'Peruutit ehdotetun toimitusajan. Voit huoletta odottaa, otamme sinuun yhteyttä uuden aikaikkunan kanssa.'
  },
  pickupPoint: {
    heading: 'Nouto-osoite',
    termsLink: '<0>Katso aukioloajat</0>'
  }
}

export default fi
